const state = {
    metrics: [],
    id: [],
    loading: false
};

export default state;